// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {buildClaimRoutes} from '../../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../../shared/services/format-claim-number';

const ClaimNumberCellRenderer = props =>
    <div className='claim-cell-renderer'>
        <a
            className='claim-link'
            href={`#${buildClaimRoutes(props.data.claimType, props.data.subClaimType, props.value)}`}
            rel='noopener noreferrer'
            target='_blank'
        >
            {formatClaimNumber(props.value)}
        </a>
    </div>;

ClaimNumberCellRenderer.displayName = 'ClaimNumberCellRenderer';
ClaimNumberCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default ClaimNumberCellRenderer;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/components/cell-renderers/claim-number-renderer.js